import { AxiosRequestConfig } from 'axios';

import { apiRequest } from 'helpers';
import { RoleEnum, UserProps } from 'types';
export const fetchUser = (user_id: number) =>
  apiRequest<UserProps>({
    method: 'GET',
    path: `/v3/users/${user_id}`,
  });

export const fetchUsers = (config: AxiosRequestConfig) => {
  return apiRequest<Array<UserProps>>({
    method: 'GET',
    path: '/v3/users',
    ...config,
  });
};

export const postUser = (config: AxiosRequestConfig) => {
  return apiRequest<UserProps>({
    method: 'POST',
    path: '/v3/users',
    ...config,
  });
};

export const patchUser = (user_id: number, config: AxiosRequestConfig) => {
  return apiRequest<UserProps>({
    method: 'PATCH',
    path: `/v3/users/${user_id}`,
    ...config,
  });
};

export const deleteUser = (user_id: number) => {
  return apiRequest({
    method: 'DELETE',
    path: `/v3/users/${user_id}`,
  });
};

export const postCurrentUser = () =>
  apiRequest<UserProps>({
    method: 'POST',
    path: '/v3/users/current',
  });

export const getCurrentUser = () =>
  apiRequest<UserProps>({
    method: 'GET',
    path: '/v3/users/current',
  });

export const patchCurrentUserRole = (selectedRole: RoleEnum) => {
  return apiRequest<UserProps>({
    method: 'PATCH',
    path: '/v3/users/current',
    data: {
      role: selectedRole,
    },
  });
};
export const postSignerSignatureImage = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiRequest({
    method: 'POST',
    path: '/v3/users/signature_upload',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getSignerSignatureImage = () =>
  apiRequest<Blob>({
    method: 'GET',
    path: '/v3/users/signature.png',
    responseType: 'blob',
    headers: {
      Accept: 'image/png',
      'Content-Type': 'multipart/form-data',
    },
  });

export const postStartMasquerade = (org_id: number) =>
  apiRequest<UserProps>({
    method: 'POST',
    path: `/v3/users/assume_employer_role/${org_id}`,
  });

export const postEndMasquerade = () =>
  apiRequest<UserProps>({
    method: 'POST',
    path: '/v3/users/revert_assumed_role',
  });
